<div class="consultar-contas-receber-container">
  <div class="card-box filtros-receber-card mb-3">
    <div class="pagina-contexto-bar">
      <p class="pagina-contexto" aria-current="page">Contas a receber</p>
      <button type="button" class="btn btn-primary btn-sm pagina-contexto-bar__acao" (click)="novo()">
        <i class="fa fa-plus"></i> Adicionar novo
      </button>
    </div>
    <div class="filtros-secao filtros-secao--basico" [class.filtros-secao--recolhida]="!filtrosBlocoConsultaVisivel">
      <button
        type="button"
        class="filtros-secao__cabecalho-toggle"
        (click)="alternarBlocoFiltro('consulta')"
        [attr.aria-expanded]="filtrosBlocoConsultaVisivel"
        aria-controls="filtros-corpo-consulta">
        <span class="filtros-secao__titulo filtros-secao__titulo--solo">Consulta</span>
        <i class="fa filtros-secao__toggle-icone" [ngClass]="filtrosBlocoConsultaVisivel ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
      </button>
      <div id="filtros-corpo-consulta" class="filtros-secao__corpo" *ngIf="filtrosBlocoConsultaVisivel">
      <div class="row g-2 filtros-secao__grid">
        <div class="col-lg-4 col-md-6">
          <label class="form-label filtros-label">Documento</label>
          <select class="form-control filtros-control" [(ngModel)]="filtroIdFinDocumento">
            <option [ngValue]="0">Todos</option>
            <option *ngFor="let item of documentos" [ngValue]="item.id">{{ item.descricao }}</option>
          </select>
        </div>
        <div class="col-lg-4 col-md-6">
          <label class="form-label filtros-label">Pago por</label>
          <input
            type="text"
            class="form-control filtros-control"
            [(ngModel)]="filtroNomePagador"
            placeholder="Nome do pagador"
          />
        </div>
        <div class="col-lg-4 col-md-6">
          <label class="form-label filtros-label">Pagamento</label>
          <select class="form-control filtros-control" [(ngModel)]="filtroPago">
            <option [ngValue]="'T'">Todos</option>
            <option [ngValue]="'S'">Pago</option>
            <option [ngValue]="'N'">Em aberto</option>
          </select>
        </div>
        <div class="col-lg-4 col-md-6">
          <label class="form-label filtros-label">Tipo recebimento</label>
          <select class="form-control filtros-control" [(ngModel)]="filtroIdTipoRecebimento">
            <option [ngValue]="0">Todos</option>
            <option *ngFor="let item of tiposRecebimento" [ngValue]="item.id">{{ item.descricao }}</option>
          </select>
        </div>
        <div class="col-lg-4 col-md-6">
          <label class="form-label filtros-label">Boleto</label>
          <select class="form-control filtros-control" [(ngModel)]="filtroBoletoGerado">
            <option [ngValue]="'T'">Todos</option>
            <option [ngValue]="'S'">Sim</option>
            <option [ngValue]="'N'">Não</option>
          </select>
        </div>
      </div>
      </div>
    </div>

    <div class="filtros-secao filtros-secao--periodos" [class.filtros-secao--recolhida]="!filtrosBlocoPeriodosVisivel">
      <button
        type="button"
        class="filtros-secao__cabecalho-toggle"
        (click)="alternarBlocoFiltro('periodos')"
        [attr.aria-expanded]="filtrosBlocoPeriodosVisivel"
        aria-controls="filtros-corpo-periodos">
        <span class="filtros-secao__titulo filtros-secao__titulo--solo">Períodos</span>
        <i class="fa filtros-secao__toggle-icone" [ngClass]="filtrosBlocoPeriodosVisivel ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
      </button>
      <div id="filtros-corpo-periodos" class="filtros-secao__corpo" *ngIf="filtrosBlocoPeriodosVisivel">
      <div class="row g-2 filtros-data-periodos">
        <div class="col-xl-4 col-md-6">
          <div class="filtro-data-grupo">
            <div class="filtro-data-grupo__titulo">Emissão</div>
            <div class="row g-1">
              <div class="col-6">
                <label class="form-label form-label-sm filtros-label-sm mb-0">De</label>
                <input type="date" class="form-control filtros-control filtros-control--data" [(ngModel)]="filtroDataEmissaoInicio" />
              </div>
              <div class="col-6">
                <label class="form-label form-label-sm filtros-label-sm mb-0">Até</label>
                <input type="date" class="form-control filtros-control filtros-control--data" [(ngModel)]="filtroDataEmissaoFim" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-md-6">
          <div class="filtro-data-grupo">
            <div class="filtro-data-grupo__titulo">Vencimento</div>
            <div class="row g-1">
              <div class="col-6">
                <label class="form-label form-label-sm filtros-label-sm mb-0">De</label>
                <input type="date" class="form-control filtros-control filtros-control--data" [(ngModel)]="filtroDataVencimentoInicio" />
              </div>
              <div class="col-6">
                <label class="form-label form-label-sm filtros-label-sm mb-0">Até</label>
                <input type="date" class="form-control filtros-control filtros-control--data" [(ngModel)]="filtroDataVencimentoFim" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-md-6">
          <div class="filtro-data-grupo">
            <div class="filtro-data-grupo__titulo">Recebimento</div>
            <div class="row g-1">
              <div class="col-6">
                <label class="form-label form-label-sm filtros-label-sm mb-0">De</label>
                <input type="date" class="form-control filtros-control filtros-control--data" [(ngModel)]="filtroDataRecebimentoInicio" />
              </div>
              <div class="col-6">
                <label class="form-label form-label-sm filtros-label-sm mb-0">Até</label>
                <input type="date" class="form-control filtros-control filtros-control--data" [(ngModel)]="filtroDataRecebimentoFim" />
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>

    <div class="filtros-secao filtros-secao--rapidos" [class.filtros-secao--recolhida]="!filtrosBlocoAtalhosVisivel">
      <button
        type="button"
        class="filtros-secao__cabecalho-toggle"
        (click)="alternarBlocoFiltro('atalhos')"
        [attr.aria-expanded]="filtrosBlocoAtalhosVisivel"
        aria-controls="filtros-corpo-atalhos">
        <span class="filtros-secao__titulo filtros-secao__titulo--solo">Atalhos</span>
        <i class="fa filtros-secao__toggle-icone" [ngClass]="filtrosBlocoAtalhosVisivel ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
      </button>
      <div id="filtros-corpo-atalhos" class="filtros-secao__corpo" *ngIf="filtrosBlocoAtalhosVisivel">
      <div class="filtros-rapidos__painel">
        <button
          type="button"
          class="filtros-rapidos__chip"
          *ngFor="let fr of filtrosRapidosList"
          [class.ativo]="filtroRapidoAtivo === fr.id"
          (click)="aplicarFiltroRapido(fr.id)">
          {{ fr.label }}
        </button>
      </div>
      </div>
    </div>

    <div class="filtros-acoes">
      <button type="button" class="btn btn-outline-secondary btn-sm filtros-acoes__btn" (click)="limparFiltros()">
        <i class="fa fa-eraser"></i> Limpar
      </button>
      <button type="button" class="btn btn-primary btn-sm filtros-acoes__btn filtros-acoes__btn--primario" (click)="buscar()">
        <i class="fa fa-search"></i> Buscar
      </button>
    </div>
  </div>

  <div class="card-box legenda-receber-card">
    <div class="previsao-real-legenda">
      <span class="previsao-real-legenda__titulo">Legenda:</span>
      <button type="button" class="previsao-real-legenda__item previsao-real-legenda__item--todos" [class.ativo]="filtroPrevisaoReal === 'T'" (click)="filtrarPorPrevisaoReal('T')">Todos</button>
      <button type="button" class="previsao-real-legenda__item previsao-real-legenda__item--previsao" [class.ativo]="filtroPrevisaoReal === 'P'" (click)="filtrarPorPrevisaoReal('P')">Previsão</button>
      <button type="button" class="previsao-real-legenda__item previsao-real-legenda__item--real" [class.ativo]="filtroPrevisaoReal === 'R'" (click)="filtrarPorPrevisaoReal('R')">Real</button>
    </div>

    <div
      #tabelaScroll
      class="table-responsive"
      [class.dragging-table]="arrastandoTabela"
      (mousedown)="iniciarArrasteTabela($event, tabelaScroll)"
      (mousemove)="moverArrasteTabela($event, tabelaScroll)"
      (mouseup)="encerrarArrasteTabela()"
      (mouseleave)="encerrarArrasteTabela()">
      <table class="table table-striped table-hover align-middle">
        <thead>
          <tr>
            <th>#</th>
            <th class="sticky-col-pago-por">Pago por</th>
            <th>Parcela</th>
            <th>Data Emissão</th>
            <th>Data Vencimento</th>
            <th>Data Recebimento</th>
            <th class="text-end">Valor imposto</th>
            <th class="text-end">Valor documento</th>
            <th class="text-end">Valor total</th>
            <th class="text-end">Outras despesas</th>
            <th class="text-end">Desconto</th>
            <th class="text-end">Multa</th>
            <th class="text-end">Custas</th>
            <th class="text-end">Juros</th>
            <th class="text-end">Recebido</th>
            <th>Centro de Custos</th>
            <th>Pago</th>
            <th>Boleto</th>
            <th>DRE</th>
            <th>Situação</th>
            <th>Documento</th>
            <th>Tipo Recebimento</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of itensPaginados; let i = index"
            [ngClass]="item.previsaoReal === 'P' ? 'linha-previsao' : 'linha-real'">
            <td>{{ ((paginaAtual - 1) * itensPorPagina) + i + 1 }}</td>
            <td class="sticky-col-pago-por">{{ item.usuarioPagador || '-' }}</td>
            <td>{{ item.parcela || '-' }}</td>
            <td>{{ item.dataEmissao }}</td>
            <td>{{ item.dataVencimento }}</td>
            <td>{{ item.dataRecebimento }}</td>
            <td class="text-end text-nowrap">{{ formatarMoedaLista(item.valorImposto) }}</td>
            <td class="text-end text-nowrap">{{ formatarMoedaLista(item.valorDocumento) }}</td>
            <td class="text-end text-nowrap">{{ formatarMoedaLista(item.valorTotal) }}</td>
            <td class="text-end text-nowrap">{{ formatarMoedaLista(item.valorOutrasDespesas) }}</td>
            <td class="text-end text-nowrap">{{ formatarMoedaLista(item.valorDesconto) }}</td>
            <td class="text-end text-nowrap">{{ formatarMoedaLista(item.valorMulta) }}</td>
            <td class="text-end text-nowrap">{{ formatarMoedaLista(item.valorCustas) }}</td>
            <td class="text-end text-nowrap">{{ formatarMoedaLista(item.valorJuros) }}</td>
            <td class="text-end text-nowrap">{{ formatarMoedaLista(item.valorRecebido) }}</td>
            <td>{{ item.centroCusto || '-' }}</td>
            <td>
              <span class="badge" [ngClass]="item.pago ? 'badge-success' : 'badge-warning'">
                {{ item.pago ? 'Sim' : 'Não' }}
              </span>
            </td>
            <td>
              <span class="badge" [ngClass]="item.boletoGerado ? 'badge-success' : 'badge-warning'">
                {{ item.boletoGerado ? 'Sim' : 'Não' }}
              </span>
            </td>
            <td>
              <span class="badge" [ngClass]="item.dre ? 'badge-success' : 'badge-warning'">
                {{ item.dre ? 'Sim' : 'Não' }}
              </span>
            </td>
            <td class="situacao-celula">
              <ng-container [ngSwitch]="situacaoRecebidoOuVencido(item)">
                <span
                  *ngSwitchCase="'recebido'"
                  class="badge situacao-badge badge-success"
                  title="Quitado na base ou com data de recebimento informada">
                  Recebido
                </span>
                <span
                  *ngSwitchCase="'vencido'"
                  class="badge situacao-badge badge-situacao-vencido"
                  title="Em aberto com vencimento anterior a hoje">
                  Vencido
                </span>
                <span
                  *ngSwitchCase="'a_vencer'"
                  class="badge situacao-badge badge-situacao-a-vencer"
                  title="Em aberto com vencimento hoje ou futuro">
                  À vencer
                </span>
                <span
                  *ngSwitchCase="'em_aberto'"
                  class="badge situacao-badge badge-situacao-em-aberto"
                  title="Em aberto sem data de vencimento utilizável para comparar">
                  Em aberto
                </span>
              </ng-container>
            </td>
            <td>{{ item.finDocumento || '-' }}</td>
            <td>{{ item.tipoRecebimento || '-' }}</td>
            <td>
              <div class="btn-group btn-group-sm" role="group">
                <button type="button" class="btn btn-outline-primary" title="Editar" (click)="editar(item)">
                  <i class="fas fa-edit"></i>
                </button>
                <button type="button" class="btn btn-outline-success" title="Pagamento" (click)="pagamento(item)">
                  <i class="fas fa-money-bill-wave"></i>
                </button>
                <button type="button" class="btn btn-outline-danger" title="Excluir" (click)="deletar(item)">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="!loading && itensPaginados.length === 0">
            <td colspan="23" class="text-center py-4">Nenhum registro encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination-wrapper mt-3">
      <div class="d-flex align-items-center gap-2">
        <label class="m-0">Itens por página:</label>
        <select class="form-control form-control-sm page-size-select" [(ngModel)]="itensPorPagina" (change)="alterarItensPorPagina()">
          <option [ngValue]="5">5</option>
          <option [ngValue]="10">10</option>
          <option [ngValue]="20">20</option>
          <option [ngValue]="50">50</option>
        </select>
      </div>

      <div class="d-flex align-items-center gap-2">
        <button class="btn btn-outline-secondary btn-sm" [disabled]="paginaAtual <= 1" (click)="paginaAnterior()">
          <i class="fa fa-chevron-left"></i> Anterior
        </button>
        <span>Página {{ paginaAtual }} de {{ totalPaginas }}</span>
        <button class="btn btn-outline-secondary btn-sm" [disabled]="paginaAtual >= totalPaginas" (click)="proximaPagina()">
          Próxima <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>
